<p-toast position="top-right"></p-toast>

<p-sidebar [(visible)]="visiblePartnerMarketingFilterPromotion"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'500px'}">
    <ng-template pTemplate="header">
        <div class="sidebar-header-title">Filter</div>
        <div class="sidebar-header-sub-title"></div>
    </ng-template>

    <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 145px)'}"
                   [styleClass]="'app-scrollpanel'">
        <div class="sidebar-field-block">
            <div class="sidebar-field__label font-bold">Status <span class="sidebar-field__label-info"></span></div>
            <div class="flex flex-row">
                <div class="pmfp-status" 
                     [class]="(filterObj.Status === 'All') ? 'pmfp-status-active' : ''"
                     (click)="clickStatus('All')">All</div>
                <div class="pmfp-status" 
                     [class]="(filterObj.Status === 'Active') ? 'pmfp-status-active' : ''"
                     (click)="clickStatus('Active')">Active</div>
                <div class="pmfp-status" 
                     [class]="(filterObj.Status === 'Inactive') ? 'pmfp-status-active' : ''"
                     (click)="clickStatus('Inactive')">Inactive</div>
            </div>
        </div>

        <div class="sidebar-field-block">
            <div class="sidebar-field__label font-bold">Promotion Type <span class="sidebar-field__label-info"></span></div>
            <div class="flex flex-row">
                <div class="col-6 p-0 pr-4">
                    <div class="sidebar-field-block">
                        <div class="sidebar-field-block">
                            <p-radioButton name="promoType"
                                           value="{{promoTypeEnum.PercentageDiscount}}"
                                           label="Percentage Discount"
                                           [(ngModel)]="filterObj.PromoTypeId"></p-radioButton>
                        </div>
                        <div class="sidebar-field-block">
                            <p-radioButton name="promoType"
                                           value="{{promoTypeEnum.FixedAmountDiscount}}"
                                           label="Fixed Amount Discount"
                                           [(ngModel)]="filterObj.PromoTypeId"></p-radioButton>
                        </div>
                    </div>
                </div>
                <div class="col-6 p-0 pl-4">
                    <div class="sidebar-field-block">
                        <div class="sidebar-field-block">
                            <p-radioButton name="promoType"
                                           value="{{promoTypeEnum.DeliveryFeeDiscount}}"
                                           label="Delivery Fee Discount"
                                           [(ngModel)]="filterObj.PromoTypeId"></p-radioButton>
                        </div>
                        <div class="sidebar-field-block">
                            <p-radioButton name="promoType"
                                           value="{{promoTypeEnum.FreeItemPromo}}"
                                           label="Free Item Promotion"
                                           [(ngModel)]="filterObj.PromoTypeId"></p-radioButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="sidebar-field-block">
            <div class="sidebar-field__label font-bold">Date <span class="sidebar-field__label-info"></span></div>
            <div class="flex flex-row">
                <div class="col-6 p-0 pr-4">
                    <div class="sidebar-field-block">
                        <div class="sidebar-field__label">Start date <span class="sidebar-field__label-info"></span></div>
                        <div class="flex flex-row">
                            <div class="sidebar-field-column">
                                <p-calendar inputId="startDate" [(ngModel)]="filterObj.StartedAt"></p-calendar>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-6 p-0 pl-4">
                    <div class="sidebar-field-block">
                        <div class="sidebar-field__label">End date <span class="sidebar-field__label-info"></span></div>
                        <div class="flex flex-row">
                            <div class="sidebar-field-column">
                                <p-calendar inputId="endDate" [(ngModel)]="filterObj.ValidUntil"></p-calendar>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </p-scrollPanel>

    <div class="flex justify-content-end mrg-10-0px">
        <button class="white-btn-filter" style="margin-right: 8px;" pButton label="Clear" (click)="uncheckFilter()"></button>
        <button class="bluedark-btn" pButton label="Apply" (click)="clickFilter()"></button>
    </div>

</p-sidebar>